import { useRef } from "react";
import { AgGridReact } from "ag-grid-react";

import Actionbar from "src/components/common/actionbar/Authactionbar";
import { Message } from "src/components/common/form/Message";
import useFetchActionbarAuth from "src/hooks/useFetchActionbarAuth";

import { Content_TQC1050_R01 } from "./Content_TQC1050_R01";
import { TQC1050_R01Dto } from "./Dto_TQC1050_R01";
import { Info_TQC1050_R01 } from "./Info_TQC1050_R01";
import { SearchSection_TQC1050_R01 } from "./SearchSection_TQC1050_R01";
import { Table_TQC1050_R01 } from "./Table_TQC1050_R01";

/**
 * 수입검사 결과등록(JC) 컨테이너.
 * 입고내역(wms_transport_dtl, inout_type='IN')에 대한 원소재 수입검사 결과를 일괄 등록한다.
 * 검사항목 컬럼은 검사기준(원소재 RM / 수입검사 IQC)에 따라 동적으로 생성된다.
 */
export const Container_TQC1050_R01 = () => {
	useFetchActionbarAuth("TQC1050_R01");

	const gridRef = useRef<AgGridReact<TQC1050_R01Dto> | null>(null);

	const {
		clickable, setClickable,
		defaultTQC1050_R01Row,
		fetchData,
		handleSaveClick,
		handleDeleteClick,
		handleExcelClick,
		handlePrintClick,
		initContainerData,
	} = Content_TQC1050_R01({ gridRef });

	return (
		<div className="content-container">
			<Actionbar
				onFetchClick={fetchData}
				onCreateClick={() => {}}
				onDeleteClick={handleDeleteClick}
				onSaveClick={handleSaveClick}
				onPrintClick={handlePrintClick}
				onExcelClick={handleExcelClick}
				onInitClick={initContainerData}
			/>
			<SearchSection_TQC1050_R01 onEnterKeyDown={fetchData} />
			<Info_TQC1050_R01 />

			<div className="flex-1 flex">
				<div className="w-full h-full flex flex-col p-[12px] gap-[12px]">
					<Table_TQC1050_R01
						clickable={clickable}
						setClickable={setClickable}
						gridRef={gridRef}
						defaultTQC1050_R01Row={defaultTQC1050_R01Row()}
					/>
				</div>
			</div>

			<Message />
		</div>
	);
};
